import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import * as webMercatorUtils from "@arcgis/core/geometry/support/webMercatorUtils.js";
import { project } from "@arcgis/core/rest/geometryService.js";
import ProjectParameters from "@arcgis/core/rest/support/ProjectParameters.js";

import { CloseCircleOutlined } from "@ant-design/icons";
import { Button, Spin, Tabs, Tooltip, notification } from "antd";
import { Content } from "antd/es/layout/layout";
import i18next from "i18next";


import * as geoprocessor from "@arcgis/core/rest/geoprocessor.js";
import { Typography } from 'antd';

const { Text, Title } = Typography;


const GpDownloadComponent = ({ downloadGPProcess, setDownloadGPProcess, uid, format, featureLayer, queryGeometry, queryWhere }) => {

    /**
     * El servicio para exportar geojson no funciona. Sale un fallo con los parámetros
     */
    const downloadSrvs = {
        "shp": "https://aplicaciones.sgv.es/arcgis/rest/services/iaa/ExportData/GPServer/toSHP",
        "xls": "https://aplicaciones.sgv.es/arcgis/rest/services/iaa/ExportData/GPServer/toXLS",
        "geojson": "https://utility.arcgisonline.com/ArcGIS/rest/services/Geometry/GeometryServer"
    }

    const placement = "topRight"

    let visible;
    const startTime = new Date();


    useEffect(() => {
        visible = true;
        drawNotification();
        download();
    }, [])

    const outResultName = () => {
        if (format == "xls") {
            return "out_xlsx";
        }
        else if (format == "shp") {
            return "out_zip";
        }
        else if (format == "geojson") {
            return "out_geojson";
        }
        else {
            return ""
        }
    }
    const closeProcess = () => {
        visible = false;
        let downloadGPProcessCopy = downloadGPProcess.filter(function (obj) {
            return obj.uid !== uid;
        });
        setDownloadGPProcess(downloadGPProcessCopy);
    }
    const setProgessValue = (value) => {
        if (!visible) return;
        notification.open({
            key: uid,
            type: "info",
            onClose: closeProcess,
            message: <>
                <Title level={5}>{i18next.t('common.tools.geoprocessing.download.title', { format: format })}
                </Title>
                <Text>{i18next.t('common.tools.geoprocessing.startTime', { startTime: startTime.toLocaleTimeString() })}
                </Text>
            </>,
            description: <>
                <Text type={"info"}>{i18next.t('common.tools.geoprocessing.runningMsg')}
                </Text><br />
                <Spin style={{ width: "100%" }} />
            </>,
            duration: 0,
            placement,
        });
    }

    const setResultData = (result) => {
        if (!visible) return;
        notification.open({
            key: uid,
            type: "success",
            onClose: closeProcess,
            message: <>
                <Title level={5}>{i18next.t('common.tools.geoprocessing.download.title', { format: format })}
                </Title>
                <Text >{i18next.t('common.tools.geoprocessing.startTime', { startTime: startTime.toLocaleTimeString() })}
                </Text>
            </>,
            description: <>
                <Text type={"success"}>{i18next.t('common.tools.geoprocessing.successMsg')}
                </Text><br />
                {/*<Text>{i18next.t('common.tools.geoprocessing.download.downloadMsg')}
                </Text><br />*/}
                {format == "geojson" && result.click()}
                {format != "geojson" && <a href={result.value.url} target="_blank">{i18next.t('common.tools.geoprocessing.download.downloadLinkMsg')}</a>} <br />
            </>,
            duration: 0,
            placement,
        });
    }

    const setErrorValue = (value) => {
        if (!visible) return;
        notification.open({
            key: uid,
            type: "error",
            onClose: closeProcess,
            message: <>
                <Title level={5}>{i18next.t('common.tools.geoprocessing.download.title', { format: format })}
                </Title>
                <Text>{i18next.t('common.tools.geoprocessing.startTime', { startTime: startTime.toLocaleTimeString() })}
                </Text>
            </>,
            description: <Text type={"error"} level={3}>{i18next.t('common.tools.geoprocessing.errorMsg')}
            </Text>,
            duration: 0,
            placement,
        });
    }

    const drawNotification = () => {
        if (!visible) return;
        notification.open({
            key: uid,
            type: "info",
            onClose: closeProcess,
            message: <>
                <Title level={5}>{i18next.t('common.tools.geoprocessing.download.title', { format: format })}
                </Title>
                <Text>{i18next.t('common.tools.geoprocessing.startTime', { startTime: startTime.toLocaleTimeString() })}
                </Text>
            </>,
            description: <Text type={"error"} level={3}>{i18next.t('common.tools.geoprocessing.pendingMsg')}
            </Text>,
            duration: 0,
            placement,
        });
    }

    const download = () => {
        let query = featureLayer.createQuery();

        if (queryGeometry) {
            query.geometry = queryGeometry;
        }
        if (queryWhere) {
            query.where = queryWhere;
        }

        if (format == "geojson") {
            downloadGeoJSON(query)
        }
        if (format == "xls") {
            downloadSHPorXLS(query)
        }
        if (format == "shp") {
            downloadSHPorXLS(query)
        }

    }

    /**
     * Esta función crea al vuelo una estrutura de objeto geojson a partir de las features obtenidas en el filtrado.
     * 
     * @param {*} query 
     */
    const downloadGeoJSON = (query) => {
        featureLayer.queryFeatures(query).then(async function (results) {
            let geoJsonFeatures = await Promise.all(results.features.map(async function (feature, index) {
                let geometry = feature.geometry;
                feature.attributes.OBJECTID = index +1
                let attributes = feature.attributes;

                console.log(index)
                console.log(feature)

                const wgs84SpatialReference = { wkid: 4326 };

                const params = new ProjectParameters({
                    geometries: [geometry],
                    outSpatialReference: wgs84SpatialReference
                });
                let paramsFeature = {}
                await project(downloadSrvs[format], params)
                    .then(result => {
                        const wgs84Point = result[0].toJSON();

                        //console.log(geometry.type)
                        const geometryOut = {
                            "type": geometry.type[0].toUpperCase() + geometry.type.slice(1),
                            "coordinates": [wgs84Point.x, wgs84Point.y]
                        }

                        paramsFeature = {
                            type: "Feature",
                            geometry: geometryOut,
                            properties: attributes,
                        };
                        return paramsFeature
                    })
                    .catch(error => {
                        console.error("Error:", error);
                    });
                    return paramsFeature
            }));

            let geoJsonData = {
                type: "FeatureCollection",
                features: geoJsonFeatures,
            };

            let geoJsonBlob = new Blob([JSON.stringify(geoJsonData)], {
                type: "application/json",
            });

            // Código para descargar el archivo GeoJSON
            let link = document.createElement("a");
            link.href = URL.createObjectURL(geoJsonBlob);
            link.download = "feature_layer.geojson";
            setResultData(link)
        });
    }

    const downloadSHPorXLS = (query) => {
        featureLayer.queryFeatures(query).then((featureSet) => {
            let json = featureSet.toJSON();
            //console.log("json", json)
            let params = { "IN_FEATURES": json }
            geoprocessor.submitJob(downloadSrvs[format], params).then((jobInfo) => {
                //console.log("jobInfo", jobInfo)
                const options = {
                    statusCallback: (jobInfo1) => {
                        setProgessValue(jobInfo);
                        //console.log("Job Status: ", jobInfo1.jobStatus);
                    }
                };

                jobInfo.waitForJobCompletion(options).then((jobInfo2) => {
                    let resultName = outResultName();
                    jobInfo.fetchResultData(resultName).then((result) => {
                        setResultData(result);
                        //console.log("result", result.value.url)
                    }).catch((error) => {
                        console.log("error", error)
                        setErrorValue(error)
                    });
                    //setResultData(jobInfo2);
                }).catch((error) => {
                    console.log("error", error)
                });
            }).catch((error) => {
                setErrorValue(error)
                console.log("error", error)
            });
        });
    }


    return (
        <>
        </>
    )
}

export default GpDownloadComponent;